// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"1eb86684","455":"c7e9df0a","977":"92866b27"}[chunkId] + ".chunk.js";
};